<template>
    <div class="lm-block-control" :class="[mapLayout]" v-if="$root.env !== 'renderer'">
        <div class="lm-block-control-inner">
            <button @click.prevent="blockMapToggle">{{value ? 'Lås upp' : 'Lås zoom'}}</button>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'TxZoomBlocker',
        props: {
            value: {},
            mapBlock: {},
            mapLayout: {}
        },
        methods: {
            blockMapToggle() {
                this.$emit('input', !this.value);
            }
        },
    }
</script>

<style lang="scss" scoped>
    .lm-block-control {
        position: absolute;
        z-index: 10;

        @media (max-width: 599px) {
            &.horizontal,
            &.vertical {
                bottom: 10px;
                left: 93px;
            }
        }
        @media (min-width: 600px) {
            &.horizontal,
            &.vertical {
                top: 10px;
                right: 10px;
            }
        }

        &-inner {
            display: flex;
            flex-direction: column;
            flex-wrap: nowrap;
            justify-content: center;
            align-content: stretch;
            align-items: stretch;

            @media (max-width: 599px) {
                flex-direction: row;
            }

            padding: 1px;
            background: rgba(255, 255, 255, 0.8);

            &-spacer {

            }

            button {
                @media (max-width: 599px) {
                    padding: 5px 15px;
                    &:first-child {
                        margin-right: 1px;
                    }
                }
                @media (min-width: 600px) {
                    &:first-child {
                        margin-bottom: 1px;
                    }
                }

                order: 0;
                flex: 0 1 auto;
                align-self: auto;

                -webkit-appearance: button;
                text-transform: none;
                font-family: inherit; /* 1 */
                line-height: 1.15; /* 1 */
                margin: 0; /* 2 */

                font-size: 18px !important;
                @media (max-width: 599px) {
                    font-size: 22px !important;
                }
                padding: 10px 20px;
                font-weight: bold;

                background: #EC7A5C;

                opacity: 1;
                transition: opacity 0.3s;
                -webkit-transition: opacity 0.3s;

                cursor: pointer;

                &:hover {
                    opacity: 0.6;
                }
            }
        }
    }

</style>